//Utility to normalize API error messages
export const extractAxiosErrorMessage = (
  err,
  fallbackMessage = "Something went wrong"
) => {
  const responseData = err?.response?.data;

  if (
    responseData &&
    typeof responseData === "object" &&
    !Array.isArray(responseData)
  ) {
    const fieldErrors = Object.values(responseData)
      .flat()
      .filter((v) => typeof v === "string");

    if (fieldErrors.length) {
      return fieldErrors[0];
    }
  }

  return (
    responseData?.message ||
    responseData?.detail ||
    (typeof responseData?.error === "string"
      ? responseData.error
      : responseData?.error?.message) ||
    responseData?.errors?.[0]?.defaultMessage ||
    fallbackMessage
  );
};
